export default __webpack_public_path__ + "static/image-5-0261b948280a1af87c29d419d13de930.jpg";